module.exports = __webpack_public_path__ + "static/media/check-mark.ada78a24.svg";